import * as React from 'react';
import { Button } from '@front10/base-elements';

// Wrapper button for control disable state of the button from outside
const WrapperButton = React.forwardRef((props, ref) => {
  const [disable, setDisable] = React.useState(true);

  React.useImperativeHandle(ref, () => ({
    disable: (value) => {
      setDisable(value);
    },
    isDisabled: () => disable
  }));

  return (
    <Button {...props} disabled={disable && props.disabled}>
      {props.children}
    </Button>
  );
});

export default WrapperButton;
